import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GraphData } from 'app/interfaces/graph-data.model';
import { BegrotingService } from 'app/services/begroting.service';
import { Program } from 'app/interfaces/program.model';

@Component({
  selector: 'app-program-graph',
  templateUrl: './program-graph.component.html',
  styleUrls: ['./program-graph.component.scss'],
})
export class ProgramGraphComponent implements OnInit, OnChanges {
  @Input() program: Program;

  graph = {
    realisatie: 45,
    prognose: 55,
    begroting: 90,
    saldo: -10,
  };

  constructor() {}

  ngOnInit() {
    console.log(this.program);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['program']) {
      const total =
        this.program.costs.space < 0
          ? this.program.costs.total + Math.abs(this.program.costs.space)
          : this.program.costs.total;
      this.graph.begroting = (this.program.costs.total / total) * 100;
      this.graph.prognose = (this.program.costs.forecast / total) * 100;
      this.graph.realisatie = (this.program.costs.realised / total) * 100;
      this.graph.saldo = (Math.abs(this.program.costs.space) / total) * 100;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/program-graph/program-graph.component.ts